import { BaseModel } from '@/api/base-model'
import { CustomerPortalBrandingAPI } from '@/api/backend-client'
import { Company } from '@/api/model/company'

export class CustomerPortalBranding extends BaseModel<CustomerPortalBranding> {
    protected collectionName = CustomerPortalBrandingAPI.collectionName

    constructor(
        public id: string,
        public logo: File|null,
        public logoPath: string,
        public name: string,
        public url: string,
        public email: string,
        public fontFamily: string,
        public buttonColorUpcoming: string,
        public buttonColorCompleted: string,
        public titleColorWelcomeUser: string,
        public textColorWelcomeUser: string,
        public subHeaderColorActive: string,
        public subHeaderColorInactive: string,
        public titleColorWoning: string,
        public textColorInfoWoning: string,
        public textColorWaardesWoning: string,
        public svgColorWaardesWoning: string,
        public buttonColorRoute: string,
        public buttonBackgroundColorRoute: string,
        public buttonColorRouteData: string,
        public titleColorDate: string,
        public textColorDate: string,
        public buttonBackgroundColorCompleted: string,
        public backgroundColorHeader: string,
        public backgroundColorPage: string,
        public emmaEnabled: boolean,

    ) { super(id) }

    get logoUrl(): string|null {
        return this.logoPath
            ? `${process.env.VUE_APP_KEYVUE_BACKEND_BASEURL}/attachments/${this.logoPath}`
            : null
    }

    static fromData(data: any): CustomerPortalBranding {
        if (data === null || typeof data === 'string' || data instanceof Comment) {
            return data
        }

        return new CustomerPortalBranding(
            data.id,
            null,
            data.logoPath,
            data.name,
            data.url,
            data.email,
            data.fontFamily,
            data.buttonColorUpcoming,
            data.buttonColorCompleted,
            data.titleColorWelcomeUser,
            data.textColorWelcomeUser,
            data.subHeaderColorActive,
            data.subHeaderColorInactive,
            data.titleColorWoning,
            data.textColorInfoWoning,
            data.textColorWaardesWoning,
            data.svgColorWaardesWoning,
            data.buttonColorRoute,
            data.buttonBackgroundColorRoute,
            data.buttonColorRouteData,
            data.titleColorDate,
            data.textColorDate,
            data.buttonBackgroundColorCompleted,
            data.backgroundColorHeader,
            data.backgroundColorPage,
            data.emmaEnabled,
        )
    }

    static new(company: Company): CustomerPortalBranding {
        return new CustomerPortalBranding(
            company.id,
            null,
            null,
            company.branding?.displayName ?? company.name ?? '',
            '',
            '',
            'Open Sans',
            '#55ee88',
            '#5588ee',
            '#111827',
            '#111827',
            '#0ea5e9',
            '#cbd5e1',
            '#111827',
            '#111827',
            '#111827',
            '#111827',
            '#f97316',
            '#fafafa',
            '#111827',
            '#38bdf8',
            '#111827',
            '#fafafa',
            '#e2e8f0',
            '#f1f5f9',
            false,
        )
    }
}
